import { t } from '@hefe/i18n';
import {
  BasketballEventType,
  BasketballTeamPlayerReplies,
  BasketballTeamPlayerReply,
} from '@hefe/models';
import {
  BasketballPracticesActions,
  BasketballTeamGameActions,
} from '@hefe/store';
import { fullUserName } from '@hefe/utils';
import { Modal, Transfer, Typography } from 'antd';
import { Key } from 'antd/es/table/interface';
import { TransferDirection, TransferItem } from 'antd/lib/transfer';
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../store/store';

interface EventTeamNomineesComponentProps {
  open: boolean;
  onClose: () => void;
  players?: BasketballTeamPlayerReplies;
  eventType: BasketballEventType;
  eventId: number;
  teamId: number;
}

export default function EventTeamNomineesComponent(
  props: EventTeamNomineesComponentProps
) {
  const dispatch = useAppDispatch();

  const [targetKeys, setTargetKeys] = useState<string[]>([]);
  const [players, setPlayers] = useState<TransferItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    const allPlayers: BasketballTeamPlayerReply[] = [];
    if (!props.players) {
      return;
    }

    for (const key in props.players) {
      const players = (props.players as any)[key];

      allPlayers.push(...players);
    }

    const nominatedKeys = [];
    const returnValue: TransferItem[] = [];
    for (const player of allPlayers) {
      if (player.nominated) {
        nominatedKeys.push(player.id + '');
      }

      returnValue.push({
        key: player.id + '',
        title: fullUserName(player),
      });
    }

    setTargetKeys([...targetKeys, ...nominatedKeys]);
    setPlayers(returnValue);
  }, [props.players]);

  const saveNominees = () => {
    setLoading(true);

    if (props.eventType === BasketballEventType.GAME) {
      dispatch(
        BasketballTeamGameActions.setBasketballTeamGameNominees({
          gameId: props.eventId,
          data: {
            team_id: props.teamId,
            nominees: targetKeys.map((key) => +key),
          },
        })
      )
        .unwrap()
        .then(() => {
          props.onClose();
        })
        .finally(() => {
          setLoading(false);
          props.onClose();
        });
    } else {
      dispatch(
        BasketballPracticesActions.setBasketballPracticeNominees({
          practice_id: props.eventId,
          data: {
            team_id: props.teamId,
            nominees: targetKeys.map((key) => +key),
          },
        })
      )
        .unwrap()
        .then(() => {
          props.onClose();
        })
        .finally(() => {
          setLoading(false);
          props.onClose();
        });
    }
  };

  const handleChange = (
    nextTargetKeys: Key[],
    direction: TransferDirection,
    moveKeys: any[]
  ) => {
    if (direction === 'right') {
      const newTargetKeys = [...new Set([...targetKeys, ...moveKeys])];
      setTargetKeys(newTargetKeys);
    } else {
      const newTargetKeys = targetKeys.filter((key) => !moveKeys.includes(key));
      setTargetKeys([...new Set(newTargetKeys)]);
    }
  };

  return (
    <Modal
      width={600}
      open={props.open}
      onCancel={props.onClose}
      onOk={() => saveNominees()}
      confirmLoading={loading}
    >
      <Typography.Paragraph>{t('nominees.info_text')}</Typography.Paragraph>
      <Transfer
        style={{ marginTop: 30 }}
        listStyle={{
          width: '100%',
        }}
        dataSource={players}
        titles={[t('nominees.not_nominated'), t('nominees.nominated')]}
        targetKeys={targetKeys}
        onChange={handleChange}
        render={(item) => item.title || ''}
      />
    </Modal>
  );
}
